import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";

const ContactUsPage = () => {
  return (
    <>
      <Navbar />
      <div className="flex flex-col items-center min-h-screen bg-[#F8F6F0] p-10">
        <br />
        <div className=" lg:w-[60%] sm:w-[80%] flex  flex-col items-center lg:mt-20">
          <h3 className="text-lg underline">Contact Us</h3>
          <p className="text-justify mt-2">
            Kondapalli , Andhra Pradesh , 521228 India
            ,Phone -
            +91-8341321652
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUsPage;
